module.exports = __webpack_public_path__ + "static/media/cookie.5737c9d7.svg";